export const firebaseConfig = {
  apiKey: 'AIzaSyBnRKzJmqr87k6pX9OvbnsAvrVpJx_dDfE',
  authDomain: 'pl-sotu-prod.firebaseapp.com',
  databaseURL: 'https://pl-sotu-prod.firebaseio.com',
};

export const SLACK_CLIENT_ID = '8629330823.81769131776';
export const ADD_TO_SLACK_URL = 'https://nzvni24cm0.execute-api.us-east-1.amazonaws.com/prod/addToSlack';
export const PING_CHANNEL_URL = 'https://nzvni24cm0.execute-api.us-east-1.amazonaws.com/prod/pingChannel';
export const SIGN_IN_WITH_SLACK_URL = 'https://nzvni24cm0.execute-api.us-east-1.amazonaws.com/prod/signInWithSlack';

export const APP_NAME = 'SOTU';
export { APP_DESCRIPTION } from './shared';
export const HOME_TITLE = 'Get SOTU';
export const APP_URL = 'https://getsotu.com';
export const APP_DOMAIN = 'getsotu.com';
export const SLASH_COMMAND = 'sotu';
export const SUPPORT_EMAIL = 'sotu@postlight.com';

export const HEAP_ID = '2244377969';
export const SENTRY_URL = 'https://96ce65ab86ae48dbbd206bd194d271f8@sentry.io/105316';

export const COMMIT_HASH = process.env.COMMIT_HASH;



/** WEBPACK FOOTER **
 ** ./src/config/prod.js
 **/